import IcomoonIcon from "./IcomoonIcon";

export default IcomoonIcon;
